import React, { useState } from "react";
import "./CustomTooltip.css";


const CustomTooltip = ({ tooltip, children, id, className }) => {
  const [activeTooltip, setActiveTooltip] = useState(null);
  
  return (
    <div
      className="tooltip-container"
      onMouseEnter={() => setActiveTooltip(id)}
      onMouseLeave={() => setActiveTooltip(null)}
    >
      {children}
      {activeTooltip === id && (
        <div className={`custom-tooltip ${className || ""}`} style={{ zIndex: 99999 }}>
          {tooltip.title && (
            <div className="tooltip-header">
              <strong>{tooltip.title}</strong>
            </div>
          )}
          <div className="tooltip-message">{tooltip.message}</div>
          {tooltip.details && (
            <div className="tooltip-details">{tooltip.details}</div>
          )}
          {tooltip.action && (
            <div className="tooltip-action">💡 {tooltip.action}</div>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomTooltip;
